import { Label } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PriceDiscount.css';

interface IPriceDiscountProps {
  oldPrice: string;
  percent: string;
}

export const PriceDiscount: React.FC<IPriceDiscountProps> = ({ oldPrice, percent }) => {
  return (
    <span className={styles['price-discount']}>
      <Label background="accent-positive-primary" color="text-inverted-default">
        {percent}
      </Label>
      <span className={styles['old-price']}>{oldPrice}</span>
    </span>
  );
};
